<template>
  <a-modal :title="'详情1'" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
           :confirm-loading="false" @cancel="onClose" width="70%">
    <a-descriptions :column="2"  bordered  :labelStyle="{width:'180px'}">
        <a-descriptions-item label="项目评审名称" :span="1">
            {{form.projectReviewName}}
        </a-descriptions-item>
        <a-descriptions-item label="计划评审时间" :span="1">
            {{form.reviewPlanTime}}
        </a-descriptions-item>

        <a-descriptions-item label="项目评审概述" :span="2">
            <div v-html="form.projectOverview"></div>
        </a-descriptions-item>
        <a-descriptions-item label="会议纪要(PDF)" :span="1">
            <FileUpload v-model:value="form.meetingMinutes" :show-btn="false" disabled></FileUpload>
        </a-descriptions-item>
        <a-descriptions-item label="项目评审内容(PDF)" :span="1">
            <FileUpload v-model:value="form.applicationAttachment" :show-btn="false" disabled></FileUpload>
        </a-descriptions-item>

        <a-descriptions-item label="补充资料(PDF)" :span="1" v-if="form.noCheckAppendFile">
            <FileUpload v-model:value="form.noCheckAppendFile" :show-btn="false" disabled></FileUpload>
        </a-descriptions-item>
      <!--可编辑区域 end-->
    </a-descriptions>
    <template #footer>
      <a-button key="back" @click="onClose">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import FileUpload from "@/components/form/upload/FileUpload";
import {formMixin} from "@/mixins";

export default {
  name: "Detail",
  components: { FileUpload },
  mixins: [formMixin],

}
</script>

<style scoped lang="less">

</style>
